import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';
import { EquipmentFunction } from './equipment-function';

export class ModelFunctions implements ViewModel {
  friendlyTypeNameSingular: string = 'Model Equipment Function';
  apiRoute: string = CONFIG.apiRoutes.equipmentFunctionModel;

  id: string;
  isPublished: boolean;
  functions: EquipmentFunction[] = [];

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.id = data.id;
    this.isPublished = data.isPublished;

    if (data.functions) {
      this.functions = data.functions.map((details: EquipmentFunction) => {
        const newFunction = new EquipmentFunction();
        newFunction.loadFromJson(details);
        return newFunction;
      });
    }
  }
}
